<template>
  <v-navigation-drawer
    :value="value"
    :mini-variant="mini && !isMobile"
    :permanent="!isMobile"
    :temporary="isMobile"
    app
    class="stone-drawer"
    @input="$emit('input', $event)"
  >
    <v-sheet class="stone-drawer__brand pa-4">
      <div class="stone-drawer__brand-inner">
        <img src="../../assets/SVG/monitora-icone.svg" class="stone-drawer__brand-logo-mini" alt="StoneUP" />
        <div v-if="!mini" class="stone-drawer__brand-text">
          <span class="stone-drawer__brand-name">Stone</span>
          <span class="stone-drawer__brand-sub">RECOVERY</span>
        </div>
      </div>
    </v-sheet>

    <v-list dense class="stone-drawer__menu">
      <v-list-item-group v-for="item in items" :key="item.id">
        <v-list-item
          dense
          exact-active-class="stone-drawer__item--active"
          v-show="item.sub_menu == '0'"
          :to="item.to"
          class="stone-drawer__item"
        >
          <v-list-item-icon>
            <v-icon color="#9aa4b2">{{ item.icon }} </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="stone-drawer__item-title">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-show="item.sub_menu != '0'" dense class="stone-drawer__group">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon color="#9aa4b2">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="stone-drawer__item-title">{{
              item.title
            }}</v-list-item-title>
          </template>
          <v-list-item dense v-for="sub in item.sub" :to="sub.to" :key="sub.id" class="stone-drawer__subitem">
            <v-list-item-icon>
              <v-icon color="#ff7a00">mdi-menu-right </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="stone-drawer__subitem-title">{{
                sub.title
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="stone-drawer__append" v-if="!mini">
        <v-btn text block class="stone-drawer__logout text-none" @click="sair">
          <v-icon left color="#8f9bb2" small>mdi-logout-variant</v-icon>
          Sair
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    items: {},
    // Aberto/fechado: só tem efeito abaixo do md, onde o menu vira gaveta sobreposta
    value: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    ...mapActions("auth", ["ActionSignOut"]),
    async sair() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(
          error.data ? error.data.message : "Não foi possivel sair do sistema"
        );
      }
    },
  },

  data: () => ({}),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
<style scoped>
.stone-drawer {
  background: linear-gradient(180deg, #0f1f3d 0%, #08142d 100%) !important;
  border-right: 1px solid #1a2a47 !important;
}

.stone-drawer__brand {
  background: transparent !important;
  border-bottom: 1px solid #1a2a47;
}

.stone-drawer__brand-inner {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stone-drawer__brand-logo-mini {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.stone-drawer__brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.stone-drawer__brand-name {
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #f3f5f9;
  letter-spacing: 0.2px;
}

.stone-drawer__brand-sub {
  font-family: 'Inter', sans-serif;
  font-size: 9px;
  font-weight: 600;
  color: #ff9a00;
  letter-spacing: 2.5px;
  margin-top: 1px;
}

.stone-drawer__menu {
  padding: 8px 10px;
}

.stone-drawer.v-navigation-drawer--mini-variant .stone-drawer__menu {
  padding-left: 0;
  padding-right: 0;
}

.stone-drawer__item,
.stone-drawer__group >>> .v-list-item {
  min-height: 40px !important;
  border-radius: 10px;
}

.stone-drawer.v-navigation-drawer--mini-variant .stone-drawer__item,
.stone-drawer.v-navigation-drawer--mini-variant .stone-drawer__group >>> .v-list-item {
  justify-content: center;
  padding: 0 !important;
}

.stone-drawer.v-navigation-drawer--mini-variant .stone-drawer__item .v-list-item__icon,
.stone-drawer.v-navigation-drawer--mini-variant .stone-drawer__group >>> .v-list-item__icon {
  margin: 0 !important;
}

.stone-drawer__item-title {
  color: #d7deeb;
  font-size: 13px;
  font-weight: 500;
}

.stone-drawer__item--active {
  background: linear-gradient(90deg, #ff7a00 0%, #ff9800 100%) !important;
}

.stone-drawer__item--active .v-icon,
.stone-drawer__item--active .stone-drawer__item-title {
  color: #ffffff !important;
}

.stone-drawer__group >>> .v-list-group__header__append-icon {
  color: #8f9bb2 !important;
}

/* espaçamentos padrão do Vuetify (32px ícone→texto, 48px pra seta) cortavam "Configurações" */
.stone-drawer:not(.v-navigation-drawer--mini-variant) .stone-drawer__item .v-list-item__icon:first-child,
.stone-drawer:not(.v-navigation-drawer--mini-variant) .stone-drawer__group >>> .v-list-item__icon:first-child {
  margin-right: 18px !important;
}
.stone-drawer:not(.v-navigation-drawer--mini-variant) .stone-drawer__group >>> .v-list-group__header__append-icon {
  min-width: 24px !important;
  margin-left: 4px !important;
}

.stone-drawer__subitem-title {
  color: #b9c4d8;
  font-size: 12px;
  font-weight: 500;
}

.stone-drawer__append {
  border-top: 1px solid #1a2a47;
  padding: 10px;
}

.stone-drawer__logout {
  color: #9fb0cb !important;
  justify-content: flex-start !important;
  border-radius: 10px;
}

.stone-drawer__logout:hover {
  background: rgba(255, 255, 255, 0.05);
}
</style>